import { __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Radio } from '../../radio/Radio.js';
import { Card } from '../../../base/card/Card.js';
import { useRadioCardGroup } from '../RadioCardGroupContext.js';
import styles from './Item.module.scss.js';

var Item = function (_a) {
    var _b, _c;
    var children = _a.children, icon = _a.icon, inputProps = _a.inputProps, className = _a.className, style = _a.style, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var variant = useRadioCardGroup().variant;
    return (jsxs(Card, __assign({ as: "label", className: clsx(styles.item, (_b = {},
            _b[styles.itemDisabled] = disabled,
            _b[styles.itemWithoutRadioHorizontal] = variant === 'withoutRadioHorizontal',
            _b[styles.itemWithoutRadioChecked] = variant !== 'withRadio' && inputProps.checked,
            _b), className), style: style, htmlFor: String(inputProps.value) }, { children: [disabled && jsx("div", { className: styles.disabledOverflow }), jsx(Radio, __assign({ showRadio: variant === 'withRadio', checkmarkClassName: styles.checkmark }, inputProps, { disabled: disabled })), jsxs("div", __assign({ className: clsx(styles.label, (_c = {},
                    _c[styles.labelWithoutRadio] = variant !== 'withRadio',
                    _c)) }, { children: [icon, jsx("span", { children: children })] }))] })));
};

export { Item };
